import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeCreateSynthesisSession } from "../../domain/use-cases/create-synthesis-session"
import { httpSynthesisSessionRepository } from "../../data/repositories/synthesis-session-repository"
import type { CreateSynthesisSessionInput } from "../../domain/entities/synthesis-session"

const create = makeCreateSynthesisSession(httpSynthesisSessionRepository)

export const useCreateSynthesisSession = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: CreateSynthesisSessionInput) => create(input),
    onSuccess: (session) => {
      void qc.invalidateQueries({
        queryKey: ["synthesis-sessions"],
        exact: true,
      })
      void qc.setQueryData(
        ["synthesis-sessions", session.id],
        session,
      )
    },
  })
}
